import { withBooking } from 'components/queries/GetBookingQuery';
import { withRouter } from 'react-router';

import MissedDepartureSeatSelection from './MissedDepartureSeatSelection.js';

export default withBooking(withRouter(MissedDepartureSeatSelection));
